import { render, staticRenderFns } from "./SupplementaryInsuranceCreate.vue?vue&type=template&id=21e00ed2"
import script from "./SupplementaryInsuranceCreate.vue?vue&type=script&lang=js"
export * from "./SupplementaryInsuranceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports